import styled from "../../theme";

export const DatePickerDiv = styled.div`
  direction: rtl;
`;
